<template>
	<b-list-group-item class="p-1">
		<b-row class="mx-0">
			<b-col cols="1" class="p-1">
				<font-awesome-icon icon="chevron-right" v-b-toggle="'weapon-details-'+index" onclick="this.classList.toggle('fa-rotate-90')"></font-awesome-icon>
			</b-col>
			<b-col cols="5" sm="6" class="p-1">
				<strong>{{weapon.Name}}</strong>
			</b-col>
			<b-col cols="2" class="p-1 text-right">
				<dice-button :data-dice-notation="totalAttack(weapon.AttackType,weapon.AttackMisc)|d20roll">
					{{totalAttack(weapon.AttackType,weapon.AttackMisc)|bonus}}
				</dice-button>
			</b-col>
			<b-col cols="4" sm="3" class="p-1 text-right">
				<dice-button :data-dice-notation="weapon.Damage">
					{{weapon.Damage}} 
				</dice-button>
			</b-col>
		</b-row>
		<b-collapse class="mx-0" :id="'weapon-details-'+index">
			<b-col cols="11" offset="1" class="p-1" v-if="weapon.Capacity != 0">
				<b-input-group>
					<b-input-group-prepend>
						<b-button variant="outline-secondary" @click="reloadWeapon()"><font-awesome-icon icon="redo"></font-awesome-icon> Reload</b-button>
					</b-input-group-prepend>
					<b-form-input v-model.number="rounds"></b-form-input>
					<b-input-group-append>
						<b-button variant="outline-secondary" @click="dischargeWeapon()"><font-awesome-icon icon="play"></font-awesome-icon> Discharge</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-col>
			<b-col cols="11" offset="1" class="p-1">
				<ul class="list-inline mb-0">
					<li class="list-inline-item" v-if="weapon.Level != ''"><strong>Level</strong> {{weapon.Level}}</li>
					<li class="list-inline-item" v-if="weapon.Price != ''"><strong>Price</strong> {{weapon.Price}}</li>
					<li class="list-inline-item" v-if="weapon.Range != ''"><strong>Range</strong> {{weapon.Range}}</li>
					<li class="list-inline-item" v-if="weapon.Critical != ''"><strong>Critical</strong> {{weapon.Critical}}</li>
					<li class="list-inline-item" v-if="weapon.Capacity != ''"><strong>Capacity</strong> {{weapon.Capacity}}</li>
					<li class="list-inline-item" v-if="weapon.Usage != ''"><strong>Usage</strong> {{weapon.Usage}}</li>
					<li class="list-inline-item" v-if="weapon.Bulk != ''"><strong>Bulk</strong> {{weapon.Bulk}}</li>
					<li class="list-inline-item" v-if="weapon.Special != ''"><strong>Special</strong> {{weapon.Special}}</li>
				</ul>
			</b-col>
		</b-collapse>
	</b-list-group-item>
</template>

<script>
import { mapGetters } from 'vuex'
import DiceButton from '@/components/DiceButton.vue'

export default {
	components: {
		DiceButton,
	},
	props: [
		'index','weapon'
	],
	computed: {
		...mapGetters([
			'currentLevel',
		]),
		...mapGetters('character/abilityScores',[
			'abilityMods',
		]),
		bab: function() {
			return this.$store.state.Character.Levels[this.currentLevel].BAB
		},
		rounds: {
			get: function(){
				return this.$store.getters['character/equipment/weapons'][this.index]
			},
			set: function(value) {
				this.setRounds(value)
			}
		}
	},
	methods: {
		setRounds: function(value) {
			this.$store.commit('setCharacterProp',[
				{
					key: `Current.Ammunition[${this.index}]`,
					val: value,
				}
			])
		},
		totalAttack: function(type, misc){
			var typeBonus = 0;
			if(type == "Melee" || type == "Thrown"){
				typeBonus = this.abilityMods.Strength;
			}else if(type == "Ranged" || type == "Operative"){
				typeBonus = this.abilityMods.Dexterity;
			}
			return typeBonus + parseInt(this.bab) + parseInt(misc);
		},
		dischargeWeapon: function() {
			this.setRounds( this.rounds - 1 )
		},
		reloadWeapon: function() {
			this.setRounds( this.weapon.Capacity )
		}
	}
}
</script>

<style scoped>

</style>